import React from 'react'
import { Box, Typography } from '@mui/material'
import { map, split } from 'lodash'
import PropTypes from 'prop-types'

function PaintworkMesh({ conditions, mesh, prefix }) {
  return (
    <Box
      sx={{
        position: 'relative',
        margin: `0 auto`,
        width: 280,
      }}
    >
      <img
        src={mesh}
        alt=""
        style={{
          width: `280px`,
          height: `auto`,
        }}
      />
      {map(
        conditions,
        (element, key) =>
          element.coords && (
            <Box
              key={key}
              id={element[`${prefix}ElementId`]}
              component="span"
              sx={{
                position: 'absolute',
                top: element.coords[0],
                left: element.coords[1],
                zIndex: '100',
              }}
            >
              <Box
                component="span"
                sx={(theme) => ({
                  position: 'absolute',
                  transform: 'translateX(-36%)',
                  whiteSpace: 'nowrap',
                  backgroundColor: theme.palette.background.default,
                })}
              >
                <Typography
                  component="span"
                  variant="caption"
                  sx={({ palette }) => ({
                    color:
                      palette.paintworkThickness[
                        element[`${prefix}PaintWorkThicknessDictId`]
                      ],
                  })}
                >
                  {
                    split(
                      element[`${prefix}PaintWorkThicknessDescription`],
                      ' – ',
                    )[0]
                  }
                </Typography>
              </Box>
            </Box>
          ),
      )}
    </Box>
  )
}

PaintworkMesh.propTypes = {
  conditions: PropTypes.array,
  mesh: PropTypes.string,
  prefix: PropTypes.string,
}
PaintworkMesh.defaultProps = {
  conditions: [],
  mesh: null,
  prefix: 'body',
}

export default PaintworkMesh
